export default "__VITE_ASSET__CHlC3QBc__"